export enum RenderingLayout {
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export type GetStaticPropsResultTemplate<T,> = {
  notFound: boolean;
} | { props: T };

export type GetStaticPropsDefaultParams = {
  params: {
    id?: string;
    layout: RenderingLayout;
    slug?: string[] | string;
  };
};

export type GetStaticPropsParams = {
  params: {
    id?: string;
    language: string;
    layout: RenderingLayout;
    pathname: string;
    slug?: string[] | string;
  };
};
